import { Grid, ListSubheader, MenuItem, Switch, TextField, Typography } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { NewVehicleSection } from './NewVehicleSection'
import {
  fetchMakesMethod,
  fetchModelsMethod,
  fetchRequestedMotorcyclesMethod,
  fetchYearsMethod,
  MOST_COMMON_MAKES,
} from '../motorcyclesUtils'

const most_common_make_upper = MOST_COMMON_MAKES.map(k => k.toUpperCase())

export const MotorcyclesYearMakeModelSection = ({ needDisabled, pushOther }) => {
  const methods = useFormContext()
  const [years, setYears] = useState([])
  const [makes, setMakes] = useState([])
  const [models, setModels] = useState([])
  const [showNewVehicleTextField, setShowNewVehicleTextField] = useState(false)
  const yearWatch = methods.watch('year')
  const makeWatch = methods.watch('make')
  const modelWatch = methods.watch('model')
  const otherVehicleWatch = methods.watch('new_vehicle_req_details')

  const fetchModels = async (inputMake, inputYear) => {
    const modelInput = methods.getValues()['model']
    let res = await fetchModelsMethod(inputMake, inputYear, pushOther)
    setModels(res.models)
    setShowNewVehicleTextField(res.showNewVehicleTextField)
    if (modelInput) {
      methods.setValue('model', modelInput)
    }
  }

  const fetchMakes = async inputYear => {
    const makeInput = methods.getValues()['make']
    let res = await fetchMakesMethod(inputYear, pushOther)
    setMakes(res)
    if (makeInput) {
      methods.setValue('make', makeInput)
    }
  }

  const fetchYears = async () => {
    let res = await fetchYearsMethod(pushOther)
    setYears(res)
  }

  const fetchRequestedMotorcycles = async (model, year) => {
    let res = await fetchRequestedMotorcyclesMethod(model, year)
    methods.setValue([{ engine_cc: res.enginecCC }, { type: res.type }])
  }
  useEffect(() => {
    fetchYears()
  }, [])

  React.useEffect(() => {
    setModels([])
    setMakes([])
    methods.setValue('model', 'modeldefault')
    methods.setValue('make', 'makedefault')

    if (yearWatch && yearWatch != '') {
      if (yearWatch == 'pre 1986') {
        setMakes([])
        setShowNewVehicleTextField(true)
      } else {
        fetchMakes(yearWatch)
        setShowNewVehicleTextField(false)
      }
    }

    if (otherVehicleWatch && otherVehicleWatch != '' && (yearWatch == 1900 || yearWatch == 'pre 1986')) {
      setShowNewVehicleTextField(true)
    }
  }, [yearWatch])

  React.useEffect(() => {
    setModels([])
    methods.setValue('model', 'modeldefault')
    if (yearWatch && yearWatch != 'yeardefault' && makeWatch && makeWatch != 'makedefault') {
      fetchModels(makeWatch, yearWatch)
    }
  }, [makeWatch])

  React.useEffect(() => {
    if (yearWatch && yearWatch != 'yeardefault' && modelWatch && modelWatch != 'modeldefault' && modelWatch != 'other') {
      fetchRequestedMotorcycles(modelWatch, yearWatch)
    }
  }, [modelWatch])

  React.useEffect(() => {
    if (yearWatch != 'yeardefault' && modelWatch != 'modeldefault') {
      setShowNewVehicleTextField(modelWatch == 'other')
    }
  }, [modelWatch])

  return (
    <>
      <Grid item xs={12} md={4}>
        <Typography>Model Year</Typography>
        <Controller
          disabled={years.length === 0 || needDisabled}
          name="year"
          rules={{ required: true, validate: x => x && x != 'yeardefault' }}
          control={methods.control}
          defaultValue={methods.control.defaultValuesRef.current.year || 'yeardefault'}
          as={
            <TextField
              InputLabelProps={{ className: 'avenir-book' }}
              error={!!methods.errors.year && 'Required'}
              variant="outlined"
              fullWidth
              select
            >
              <MenuItem disabled value={'yeardefault'}>
                <div className="placeholder-text avenir-book">Model Year</div>
              </MenuItem>
              {years.map(item => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
          }
        />
      </Grid>
      {makes.length > 0 ? (
        <Grid item xs={12} md={4}>
          <Typography>Make</Typography>
          <Controller
            disabled={makes.length == 0 || needDisabled}
            name="make"
            rules={{ required: true, validate: x => x && x != 'makedefault' }}
            control={methods.control}
            defaultValue={methods.control.defaultValuesRef.current.make || 'makedefault'}
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!methods.errors.make && 'Required'}
                variant="outlined"
                fullWidth
                select
              >
                <MenuItem disabled value={'makedefault'}>
                  <div className="placeholder-text avenir-book">Make</div>
                </MenuItem>
                <ListSubheader disableSticky>
                  <div className="text-small-title black bolder">Most Common Manufacturers</div>
                </ListSubheader>
                {most_common_make_upper
                  .filter(item => makes.includes(item))
                  .map(item => (
                    <MenuItem className="margin-left-basic" key={item} value={item.toUpperCase()}>
                      {item.toUpperCase()}
                    </MenuItem>
                  ))}
                <ListSubheader disableSticky>
                  <div className="text-small-title black bolder">All Manufacturers</div>
                </ListSubheader>
                {makes.map(item => (
                  <MenuItem className="margin-left-basic" key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            }
          />
        </Grid>
      ) : (
        <Grid item xs={12} md={4}></Grid>
      )}
      {models.length > 0 ? (
        <Grid item xs={12} md={4}>
          <Typography>Model</Typography>
          <Controller
            disabled={models.length == 0 || needDisabled}
            name="model"
            rules={{ required: true, validate: x => x && x != 'modeldefault' }}
            control={methods.control}
            defaultValue={methods.control.defaultValuesRef.current.model || 'modeldefault'}
            as={
              <TextField
                InputLabelProps={{ className: 'avenir-book' }}
                error={!!methods.errors.model && 'Required'}
                variant="outlined"
                fullWidth
                select
              >
                <MenuItem disabled value={'modeldefault'}>
                  <div className="placeholder-text avenir-book">Model</div>
                </MenuItem>
                {models.map(item => (
                  <MenuItem key={item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </TextField>
            }
          />
        </Grid>
      ) : (
        <Grid item xs={12} md={4}></Grid>
      )}
      {showNewVehicleTextField && <NewVehicleSection />}
    </>
  )
}
